import { render, staticRenderFns } from "./BranchTimeDelete.vue?vue&type=template&id=2025cb5d&scoped=true&"
import script from "./BranchTimeDelete.vue?vue&type=script&lang=js&"
export * from "./BranchTimeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025cb5d",
  null
  
)

export default component.exports